<dgx-components-panel
  [dgxQmSanitise]="'block'"
  class="protection-confirmation-panel-header"
  variant="primary-alternative"
>
  <dgx-components-rich-text [content]="content" />
</dgx-components-panel>
